/**
 * Имена GraphQL-операций мессенджера для Apollo refetchQueries.
 * По образцу scenario-query-keys.ts.
 */
export const messengerQueryNames = {
  getMessengerChannels: 'GetMessengerChannels',
  getMessengerConversationGroups: 'GetMessengerConversationGroups',
  getClientMessengerConversations: 'GetClientMessengerConversations',
} as const;
